import { t } from 'i18next'
import { authPort } from '@/infra/config/beans'
import { VpButton } from '@vtmn-play/react'
import { trackAndFlushEvent } from '@/src/analytics/amplitude'

export const LogoutButton = () => {
  const handleClick = () => {
    void trackAndFlushEvent('LOGOUT_BUTTON_CLICK').finally(() => authPort.logout())
  }
  return (
    <VpButton
      className="flex justify-between items-center py-3 hover:bg-gray-50 rounded-md px-2 -mx-2"
      variant="tertiary"
      onClick={handleClick}
    >
      {t('global.logout')}
    </VpButton>
  )
}
